import { StatusTypes } from 'src/app/Shared/Enums/statusTypes';
import { Status } from './../../Enums/status';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APIResponse, NodeTree, SalesPoint } from '../../Entity';
import { CommonService } from '../Common/common.service';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class UserService {
    public baseUrl: string;
    private passwordExpired: boolean;    

    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string,
        private commonService: CommonService) {        
        this.baseUrl = baseUrl + 'api/';
    }
    /////////////////////CM User///////////

    getUserList(pageIndex:number,pageSize:number,search:string,status:StatusTypes) {
        return this.http.get<APIResponse>(this.baseUrl + `v1/user?pageIndex=${pageIndex}&pageSize=${pageSize}&search=${search}&status=${status}`);
    }
    getUserById(id) {
        return this.http.get(`${this.baseUrl}v1/user/${id}`);
    }
    createUser(userModel) {        
        return this.http.post(this.baseUrl + 'v1/user/create', userModel);
    }
    updateUser(userModel) {        
        return this.http.put(this.baseUrl + 'v1/user/update', userModel);

    }
    confirmUser(id:number, approvalStatus:number) {        
        return this.http.put(this.baseUrl + `v1/user/confirmUser?id=${id}&approvalStatus=${approvalStatus}`, {});

    }
    deleteUser(id) {
        return this.http.delete(`${this.baseUrl}v1/user/delete/${id}`);
    }
    excelImportUser(model) {
        return this.http.post(`${this.baseUrl}v1/user/excelImport`, this.commonService.toFormData(model));
    }
    public exportUserToExcel(search: string, status: StatusTypes) {
        return this.http.get(`${this.baseUrl}/v1/user/ExportUserToExcel?search=${search}&status=${status}`,{responseType: 'blob'});
    }
    
    //public postUser(model) {
    //    return this.http.post<APIResponse>(this.baseUrl + 'v1/user/save', model);
    //}

    //public postRoleLinkWithUser(model) {
    //    return this.http.post<APIResponse>(this.baseUrl + 'v1/user/rolelinkwithuser', model);
    //}



    /////////////////User Info /////////////
createUserInfo(userInfoModel) {        
        return this.http.post(this.baseUrl + 'v1/userinfo/create', userInfoModel);
    }
    updateUserInfo(userInfoModel) {        
        return this.http.put(this.baseUrl + 'v1/userinfo/update', userInfoModel);

    }
    getAllUserInfo() {
        return this.http.get<APIResponse>(this.baseUrl + 'v1/userinfo');
    }
     getAllSalesPoint() {
        return this.http.get<APIResponse<SalesPoint[]>>(this.baseUrl + 'v1/SalesPoint/');
    }
    getAllSalesPointByCurrentUser() {
        return this.http.get<APIResponse<SalesPoint[]>>(this.baseUrl + 'v1/SalesPoint/GetAllSalesPointByCurrentFmUser');
    }//nodeHierarchies

    getNodeTreeByCurrentUser() {
        return this.http.get<NodeTree[]>(this.baseUrl + 'v1/Node/GetNodeTreeByCurrentFmUser');
    }//nodeHierarchies

    getNodeTreeForAllUser() {
        return this.http.get<NodeTree[]>(this.baseUrl + 'v1/Node/GetAllNodeTree');
    }//nodeHierarchies


    getUserInfoById(id) {
        return this.http.get(`${this.baseUrl}v1/userinfo/${id}`);
    }

    getDesignationCodeById(id) {
        return this.http.get(`${this.baseUrl}v1/userinfo/designationcode/${id}`);
    }

    deleteUserInfo(id) {

        return this.http.delete<any>(`${this.baseUrl}v1/userinfo/delete/${id}`);
    }

    public postUser(model) {
        return this.http.post<APIResponse>(this.baseUrl + 'v1/userinfo/save', model);
    }

    public postRoleLinkWithUser(model) {
        return this.http.post<APIResponse>(this.baseUrl + 'v1/userinfo/rolelinkwithuser', model);
    }

    public resetPassword(model) {
        return this.http.put<APIResponse>(this.baseUrl + 'v1/userinfo/resetpassword', model);
    }

    public exportUserInfoToExcel() {
        return this.http.get(`${this.baseUrl}/v1/userinfo/ExportUserInfoToExcel`,{responseType: 'blob'});
    }
    /////////////////Hierarchy /////////////

    getAllHierarchy() {
        return this.http.get<APIResponse>(this.baseUrl + 'v1/userinfo/hierarchy');
    }

    getUserTypeCode(userTypeId:number) { 
        return this.http.get<APIResponse>(this.baseUrl + 'v1/user/GetUserTypeCode?userTypeId=' + userTypeId);
    }

    getFssUserBySalespoint(salespointId:number) { 
        return this.http.get<APIResponse>(`${this.baseUrl}v1/user/fssUserBySalesPoint/${salespointId}`);
    }
    getCmrUserBySalespoint(salespointId:number) { 
        return this.http.get<APIResponse>(`${this.baseUrl}v1/user/cmrBySalesPoint/${salespointId}`);
    }

     getPasswordExpired(){
        return this.http.get<boolean>(`${this.baseUrl}v1/UserInfo/IsPasswordExpired`)
            .pipe(
                map(response => {
                    this.passwordExpired = response;
                    return this.passwordExpired;
                }));
    }

    public getPasswordExpiredDay() {
        return this.http.get<number>(this.baseUrl + 'v1/userinfo/GetPasswordExpiredDay');
    }

   
}